import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Home from "../views/Home.vue";
import Homev2 from "../views/Homev2.vue";
import MainTemplate from "../views/MainTemplate.vue";
import TravelPlanning from "../views/travel_planning/TravelPlanning.vue";
import TravelPlanningCarJourneys from "../views/travel_planning/TravelPlanningCarJourneys.vue";
import TravelPlanningTravelHabits from "../views/travel_planning/TravelPlanningTravelHabits.vue";
import TravelPlanningSummary from "../views/travel_planning/TravelPlanningSummary.vue";
import TravelPlanningSustainableTravel from "../views/travel_planning/TravelPlanningSustainableTravel.vue";
import EngagementMetrics from "../views/travel_planning/EngagementMetrics.vue";

import Maps from "../views/Maps.vue";
import Heatmap from "../views/HeatMap.vue";
import MapsMain from "../views/MapsMain.vue";
import Actions from "../views/Actions.vue";
import Packages from "../views/superadmin/Packages.vue";
import Automations from "../views/superadmin/Automations.vue";
// import ML from "../views/superadmin/ML.vue";
import StepActions from "../views/superadmin/StepActions.vue";
import SchoolIntegrations from "../views/superadmin/SchoolIntegrations.vue";
import AutomationsLogs from "../views/superadmin/AutomationsLogs.vue";
import AutomationDetailedLogs from "../views/superadmin/AutomationDetailedLogs.vue";
import MailgunTemplates from "../views/superadmin/MailgunTemplates.vue";
import RawMailgunTemplates from "../views/superadmin/RawMailgunTemplates.vue";
import NoticesTemplates from "../views/superadmin/NoticesTemplates.vue";
import SingleMailgunTemplate from "../views/superadmin/SingleMailgunTemplate.vue";

import SingleAction from "../views/SingleAction.vue";
import Logout from "../views/Logout.vue";
import Schools from "../views/Organizations.vue";
import Organizations from "../views/Organizations.vue";
import NewEditCouncil from "../views/admin/NewEditCouncil.vue";
import NewEditOrganization from "../views/admin/NewEditOrganization.vue";
import Councils from "../views/Councils.vue";
import Surveys from "../views/Surveys.vue";
import Feedback from "../views/Feedback.vue";
import Noticeboard from "../views/Noticeboard.vue";
import CreatePost from "../views/CreatePost.vue";
import Account from "../views/Account.vue";
import TravelFeatures from "../views/school/TravelFeatures.vue";
import AdminMessages from "../views/AdminMessages.vue";
import SignupCentre from "../views/SignupCentre.vue";

// School data
import UsersWrapper from "../views/school/UsersWrapper.vue";
import Staff from "../views/school/Staff.vue";
import Parents from "../views/school/Parents.vue";
import Pupils from "../views/school/Pupils.vue";
import Descriptions from "@/constants/description.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout,
  },
  {
    path: "/members",
    name: "MainTemplate",
    component: MainTemplate,
    children: [
      {
        path: "home",
        name: "Home",
        component: Home,
      },
      {
        path: "homev2",
        name: "Homev2",
        component: Homev2,
      },
      {
        path: "account",
        name: "Account",
        component: Account,
        meta: {
          description: Descriptions.account,
        },
      },
      {
        path: "travel_features/:type?/:id?",
        name: "Travel Directory Editor",
        component: TravelFeatures,
        meta: {
          description: Descriptions.travel_features,
        },
      },
      {
        path: "school_integrations",
        name: "School Integrations",
        component: SchoolIntegrations,
        meta: {
          description: Descriptions.school_integrations,
        },
      },
      {
        path: "travel_planning",
        name: "Travel Planning",
        component: TravelPlanning,
        children: [
          {
            path: "summary",
            name: "Travel Plan Metrics | Summary",
            component: TravelPlanningSummary,
            meta: {
              description: Descriptions.summary,
            },
          },
          {
            path: "travel_habits",
            name: "Travel Plan Metrics | Travel Habits",
            component: TravelPlanningTravelHabits,
            meta: {
              description: Descriptions.travel_habits,
            },
          },
          {
            path: "car_journeys",
            name: "Travel Plan Metrics | Car Journeys",
            component: TravelPlanningCarJourneys,
            meta: {
              description: Descriptions.car_journeys,
            },
          },
          {
            path: "sustainable_travel",
            name: "Travel Plan Metrics | Sustainable Travel",
            component: TravelPlanningSustainableTravel,
            meta: {
              description: Descriptions.sustainable_travel,
            },
          },
          {
            path: "engagement",
            name: "Metrics | Engagement",
            component: EngagementMetrics,
            meta: {
              description: Descriptions.engagement,
            },
          },
        ],
        // Summary, Travel Habits, Car Journeys & Sustainable Travel
      },
      {
        path: "maps",
        name: "Mapsold",
        component: MapsMain,
      },
      {
        path: "maps/:category",
        name: "Travel Plan Maps",
        component: Maps,
        meta: {
          description: Descriptions.maps,
        },
      },
      {
        path: "heatmap",
        name: "Journey(Heatmap) Maps",
        component: Heatmap,
        meta: {
          description: Descriptions.heatmap,
        },
      },
      {
        path: "schools",
        name: "Schools",
        component: Schools,
        meta: {
          description: Descriptions.schools,
        },
      },
      {
        path: "organizations/:type",
        name: "Organizations",
        component: Organizations,
        meta: {
          description: Descriptions.schools,
        },
      },
      {
        path: "organization/:org_id?",
        name: "Edit Organization",
        component: NewEditOrganization,
        meta: {
          description: Descriptions.edit_school,
        },
      },
      {
        path: "signups",
        name: "Sign-ups & Users",
        component: SignupCentre,
        meta: {
          description: Descriptions.signups,
        },
      },
      {
        path: "councils",
        name: "Councils",
        component: Councils,
        meta: {
          description: Descriptions.councils,
        },
      },
      {
        path: "council/:council_id?",
        name: "Edit Council",
        component: NewEditCouncil,
        meta: {
          description: Descriptions.edit_council,
        },
      },
      {
        path: "noticeboard",
        name: "Notice Board",
        component: Noticeboard,
        meta: {
          description: Descriptions.noticeboard,
        },
      },
      {
        path: "noticeboard/edit/:new?",
        name: "Edit Message",
        component: CreatePost,
        meta: {
          description: Descriptions.create_post,
        },
      },
      {
        path: "users",
        name: "Users",
        component: UsersWrapper,
        children: [
          {
            path: "pupils",
            name: "Pupils",
            component: Pupils,
            meta: {
              description: Descriptions.pupils,
            },
          },
          {
            path: "parents",
            name: "Parents",
            component: Parents,
            meta: {
              description: Descriptions.parents,
            },
          },
          {
            path: "staff",
            name: "Staff",
            component: Staff,
            meta: {
              description: Descriptions.staff,
            },
          },
        ],
        // Summary, Travel Habits, Car Journeys & Sustainable Travel
      },
      // {
      //   path: "staff_list",
      //   name: "Staff",
      //   component: StaffList
      // },
      {
        path: "actions",
        name: "Actions",
        component: Actions,
        meta: {
          description: Descriptions.actions,
        },
      },
      {
        path: "automations",
        name: "Automations",
        component: Automations,
        meta: {
          description: Descriptions.automations,
        },
      },
      {
        path: "automations/logs",
        name: "Automations logs",
        component: AutomationsLogs,
      },
      {
        path: "automations/detailed_logs/:automation_id",
        name: "Automation detailed logs",
        component: AutomationDetailedLogs,
      },
      {
        path: "automations/mailgun_templates",
        name: "Mailgun Templates",
        component: MailgunTemplates,
      },
      {
        path: "automations/raw_mailgun_templates",
        name: "Raw Mailgun Templates",
        component: RawMailgunTemplates,
      },
      {
        path: "automations/notice_templates",
        name: "Notice Templates",
        component: NoticesTemplates,
      },
      {
        path: "automations/mailgun_templates/:id",
        name: "Mailgun Template",
        component: SingleMailgunTemplate,
      },
      {
        path: "step_actions",
        name: "Step Actions",
        component: StepActions,
        meta: {
          description: Descriptions.automations,
        },
      },
      {
        path: "packages",
        name: "Packages",
        component: Packages,
      },
      {
        path: "actions/:action",
        name: "Admin Action",
        component: SingleAction,
      },
      {
        path: "admin_messages",
        name: "Inbox",
        component: AdminMessages,
      },
      {
        path: "feedback",
        name: "Feedback",
        component: Feedback,
      },
      {
        path: "surveys",
        name: "Surveys",
        component: Surveys,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
